function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { SlotChildObserveController } from '@vaadin/component-base/src/slot-child-observe-controller.js';
/**
 * A controller that manages the error message node content.
 */

export var ErrorController = /*#__PURE__*/function (_SlotChildObserveCont) {
  _inherits(ErrorController, _SlotChildObserveCont);

  var _super = _createSuper(ErrorController);

  function ErrorController(host) {
    _classCallCheck(this, ErrorController);

    return _super.call(this, host, 'error-message', 'div');
  }
  /**
   * Set the error message element text content.
   *
   * @param {string} errorMessage
   */


  _createClass(ErrorController, [{
    key: "setErrorMessage",
    value: function setErrorMessage(errorMessage) {
      this.errorMessage = errorMessage;
      this.updateDefaultNode(this.node);
    }
    /**
     * Set invalid state for detecting whether to show error message.
     *
     * @param {boolean} invalid
     */

  }, {
    key: "setInvalid",
    value: function setInvalid(invalid) {
      this.invalid = invalid;
      this.updateDefaultNode(this.node);
    }
    /**
     * Override method inherited from `SlotController` to not run
     * initializer on the custom slotted node unnecessarily.
     *
     * @param {Node} node
     * @protected
     * @override
     */

  }, {
    key: "initAddedNode",
    value: function initAddedNode(node) {
      if (node !== this.defaultNode) {
        // There is no need to run `initNode`.
        this.initCustomNode(node);
      }
    }
    /**
     * Override to initialize the newly added default error message.
     *
     * @param {Node} errorNode
     * @protected
     * @override
     */

  }, {
    key: "initNode",
    value: function initNode(errorNode) {
      this.updateDefaultNode(errorNode);
    }
    /**
     * Override to initialize the newly added custom error message.
     *
     * @param {Node} errorNode
     * @protected
     * @override
     */

  }, {
    key: "initCustomNode",
    value: function initCustomNode(errorNode) {
      // Save the custom error message content on the host.
      if (errorNode.textContent && !this.errorMessage) {
        this.errorMessage = errorNode.textContent.trim();
      } // Notify the host about custom node.


      _get(_getPrototypeOf(ErrorController.prototype), "initCustomNode", this).call(this, errorNode);
    }
    /**
     * Override method inherited from `SlotChildObserveController`
     * to restore the default error message element.
     *
     * @protected
     * @override
     */

  }, {
    key: "restoreDefaultNode",
    value: function restoreDefaultNode() {
      this.attachDefaultNode();
    }
    /**
     * Override method inherited from `SlotChildObserveController`
     * to update the error message text and hidden state.
     *
     * Note: unlike with other controllers, this method is
     * called for both default and custom error message.
     *
     * @param {Node | undefined} node
     * @protected
     * @override
     */

  }, {
    key: "updateDefaultNode",
    value: function updateDefaultNode(errorNode) {
      var errorMessage = this.errorMessage,
          invalid = this.invalid;
      var hasError = Boolean(invalid && errorMessage && errorMessage.trim() !== '');

      if (errorNode) {
        errorNode.textContent = hasError ? errorMessage : '';
        errorNode.hidden = !hasError; // Role alert will make the error message announce immediately
        // as the field becomes invalid

        if (hasError) {
          errorNode.setAttribute('role', 'alert');
        } else {
          errorNode.removeAttribute('role');
        }
      } // Notify the host after update.


      _get(_getPrototypeOf(ErrorController.prototype), "updateDefaultNode", this).call(this, errorNode);
    }
  }]);

  return ErrorController;
}(SlotChildObserveController);